import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { authAtom } from '../services/auth.service';
import { telemetry } from '../services/persera-telemetry-browser';

/**
 * Page views and client errors for the Persera hub (Admin → Telemetry), so the funnel can follow a visitor from the
 * landing page to signing in. persera-telemetry-browser.ts is the hub's SDK, copied as-is.
 *
 * GDPR: nothing is collected or stored until the cookie banner is accepted (the same choice that turns on Google
 * Analytics). The server-side funnel counts in utils/funnel don't depend on this.
 */
telemetry.init({
    consent: () => {
        try {
            return localStorage.getItem('cookie') === 'accepted';
        } catch (e) {
            return false;
        }
    }
});

export const TelemetryTracker = () => {
    const { pathname } = useLocation();
    const user = useAtomValue(authAtom);

    React.useEffect(() => {
        telemetry.identify(user ? user.guid : undefined);
    }, [user ? user.guid : undefined]);

    React.useEffect(() => {
        telemetry.page(pathname);
    }, [pathname]);

    return null;
};
